import React, { useState } from 'react';
import { CgSearch } from "react-icons/cg";
import { useForm } from "react-hook-form";
import Api from '../../../../services/Api';
import { toast } from 'react-hot-toast';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
const StepOne = ({ activeStep,setActiveStep,nextStep,setPaiement, paiement,handleInput,isFind,setIsFind }) => {
    const [isLoading, setIsLoading] = useRecoilState(loadingState);
     const { register, handleSubmit, reset,trigger, setValue,setError, formState: { errors } } = useForm({
        defaultValues: {
            demandeur:{
                fullName: paiement.demandeur.fullName,
                adresse: paiement.demandeur.adresse,
                telephone: paiement.demandeur.telephone,
                email: paiement.demandeur.email,
                nina: paiement.demandeur.nina,
                denominationSociete: paiement.demandeur.denominationSociete,
                rccm: paiement.demandeur.rccm,
                typeDemandeur: paiement.demandeur.typeDemandeur,
               },
               infovehicule:{ 
                marque: paiement.infovehicule.marque,
                modele: paiement.infovehicule.modele,
                numeroChassis: paiement.infovehicule.numeroChassis,
                categorie: paiement.infovehicule.categorie,  
                ptac: paiement.infovehicule.ptac,
                dateMiseCirculation: paiement.infovehicule.dateMiseCirculation,
                paysProvenance: paiement.infovehicule.paysProvenance,
                paysDestination: paiement.infovehicule?.paysDestination || "N/A",
                dossier: paiement.infovehicule.dossier,
                poidsTotalRoulant: paiement.infovehicule.poidsTotalRoulant,
                poidsAVide: paiement.infovehicule.poidsAVide,
                puissanceFiscale: paiement.infovehicule.puissanceFiscale,
                chargeUtile: paiement.infovehicule.chargeUtile,
                couleur: paiement.infovehicule.couleur,
                otherColor: paiement.infovehicule.otherColor
           }
        },
      });
      
      const api = new Api();
      const handleSearch = async () => {
        try{
            setIsLoading(true);
            const { status,errors, data } = await api.apiData("get",`/paiement/apc/invoice?invoice_id=${paiement.reference}`);
            setIsFind(false);setError("reference",null);
            //console.log(data);
            if(status === 200){
            if(data.length > 0){
                setIsFind(true);
                //console.log(data[0]);
                setPaiement({
                    ...paiement,
                    demandeur: {
                        fullName: data[0].fullName,
                        adresse: data[0].adresse,
                        telephone: data[0].telephone,
                        email: data[0].email,
                        nina: data[0].nina,
                        denominationSociete: data[0].denominationSociete,
                        rccm: data[0].rccm,
                        typeDemandeur: data[0].typeDemandeur,
                    },
                    infovehicule:{
                        marque: data[0].marqueName,
                        modele: data[0].modeleName,
                        numeroChassis: data.map((item) => item.numeroChassis),
                        categorie: data[0].categorie,  
                        ptac: data[0].ptac,
                        dateMiseCirculation: data[0].dateMiseCirculation,
                        paysProvenance: data[0].paysProvenance,
                        paysDestination: data[0].paysDestination,
                        dossier: data[0].dossierPath,
                        poidsTotalRoulant: data[0].poidsTotalRoulant,
                        poidsAVide: data[0].poidsAVide,
                        puissanceFiscale: data[0].puissanceFiscale,
                        chargeUtile: data[0].chargeUtile,
                        couleur: data[0].couleur === "autre" ? data[0].otherColor : data[0].couleur,
                    
                    },
                    reference: data[0].groupID,
                });
                
            }
            else{
                const reference = paiement.reference;
                reset();
                setValue("reference",reference);
                setPaiement({
                    ...paiement,
                    reference: reference,
                });
                setError("reference",{
                    type: "required",
                    message: "Aucun paiement trouvé",
                });
                setIsFind(false);
                toast.error("Aucun paiement trouvé");
            }
            }
        }
        catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
     }
     const onSubmit = (data) => {
        console.log(data);
        nextStep();
     }
 // console.log(errors.reference);
   return (
    <div className='step-component step-one'>
        <form onSubmit={handleSubmit(onSubmit)}>
           <div className='input-group'>
           <label className='obligatoire'>Référence du paiement
           <div className="input-with-icon">
             <input 
               type='text'
               name='reference'
               value={paiement?.reference?.toUpperCase() || ""}
               placeholder="Référence du paiement de l'attestation"
               {...register("reference", {
                required: "La référence du paiement est obligatoire",
                minLength: {
                value: 5, // Ajustez selon les règles locales
                message: "La référence du paiement doit contenir 5 caractères",
                },
                maxLength: {
                value: 20, // Ajustez si nécessaire
                message: "La référence du paiement ne doit pas dépasser 15 caractères",
                },
               
                onChange: (e) => handleInput(e), // Gestionnaire personnalisé
              })}
             /> 
             <span className="search-icon" onClick={handleSearch}>
                <CgSearch size={20} />
             </span>
            </div> 
             {errors.reference && (
                <>
                {["required","minLength", "maxLength"].map((errorType) => (
                    errors.reference?.type === errorType && (
                    <span key={errorType} className="error-msg">
                        {errors.reference.message}
                    </span>
                    )
                ))}
                </>
              )}
           </label> 
           </div>
          <div className="buttons">
            <button type="submit" disabled={!isFind}>Suivant</button>
         </div>
        </form>
    </div>
   )
}

export default StepOne;